<template>
  <div class="container-fluid">
    <div class="row pt-4">
      <div class="col-8">
        <p class="page-title">
          <i class="fas fa-align-justify"></i> Series
        </p>
      </div>
      <div class="col-4">
        <div class="input-group md-form form-sm form-2 pl-0 table-filter">
          <button
            type="button"
            class="btn btn-primary btn-sm mr-2"
            @click="createNewSerie"
          >
            <i class="fas fa-plus"></i>
          </button>
          <input class="col" name="query" v-model="searchQuery" placeholder="Search" />
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="fas fa-filter text-grey" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <GridTable :data="gridData" :sortable=true @sortData="changePage($event)" :columns="gridColumns" :filter-key="searchQuery" />
        <b-pagination
          size="sm"
          v-model="page"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          @change="changePage($event)"
        />
        <ExporterImporterData title="Series" url="/series" :filter="searchQuery" @import="handleImportData" />
      </div>
    </div>
    <b-modal ref="modal" :title="modal.title" size="xl" ok-only>
      <p style="white-space: pre;">{{ modal.content }}</p>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BPagination } from 'bootstrap-vue';
//import { GridTable } from '@dmunoz/gridtable';
import GridTable from '@/components/MarketplacesGrid/MarketplacesGrid.vue';
import SeriesApiRequest from '@/components/ApiRequester/Series';
import ExporterImporterData from '@/components/Common/ImporterExporterData';
import router from '@/router';

const ApiRequest = new SeriesApiRequest();

export default {
  name: 'Series',
  components: {
    GridTable,
    BPagination,
    BModal,
    ExporterImporterData
  },
  data() {
    return {
      modal: {
        title: '',
        content: '',
      },
      searchQuery: '',
      totalRows: 0,
      page: 1,
      sortable: true,
      gridData: [],
      gridColumns: [
        {
          column: 'Series',
          index: 'series',
          type: 'link',
          path: '/series/:id/edit',
          sortable: "sku",
          defaultSort: 1,
        },
        {
          column: 'Category',
          index: 'product_category',
          type: 'raw',
          sortable: "category",
          defaultSort: 1,
        },
        {
          column: 'Type',
          index: 'product_type',
          type: 'raw',
          sortable: "type",
          defaultSort: 1,
        },
        {
          column: 'Enable',
          index: 'enable',
          type: 'bool',
          size: '200px',
          align: 'center',
          sortable: "enable",
          defaultSort: 1,
        },
      ],
    };
  },
  computed: {
    perPage: () => 100
  },
  mounted() {
    document.getElementById('loader').classList.add('active');
    ApiRequest.all({
      page: this.page,
      per_page: this.perPage,
    }).then((response) => {
      const { total, data } = response.data;
      this.gridData = data;
      this.totalRows = total;
      document.getElementById('loader').classList.remove('active');
    }).catch(() => {
      document.getElementById('loader').classList.remove('active');
    });
    ApiRequest.finishCall();
  },
  watch: {
    searchQuery(newV) {
      document.getElementById('loader').classList.add('active');

      ApiRequest.cancelPreviousRequest();
      ApiRequest.all({
        filter: newV,
      }).then((response) => {
        const { data, total } = response.data;
        this.gridData = data;
        this.totalRows = total;
        document.getElementById('loader').classList.remove('active');
        ApiRequest.finishCall();
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    },
  },
  methods: {
    changePage(obj) {
      this.gridData = [];
      let payload = { page: obj };

      if (this.searchQuery !== '') {
        payload = Object.assign(payload, {
          filter: this.searchQuery,
        });
      }

      if (obj['key'] !== '') {
        payload = Object.assign(payload, {
          sortKey: obj['key'],
        });
      }

      if (obj['direction'] !== '') {
        payload = Object.assign(payload, {
          sortOrders: obj['direction'],
        });
      }

      document.getElementById('loader').classList.add('active');
      ApiRequest.all(payload).then((response) => {
        const { data, total } = response.data
        this.gridData = Array.isArray(data) ? data : Object.values(data);
        this.totalRows = total;
        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
    },
    createNewSerie() {
      router.push('/series/create')
    },
    handleImportData(response) {
      switch (response.status) {
        case 'success':
          this.modal = Object.assign({}, {
            title: 'Success',
            content: 'The file was imported successfully',
          });
          break;
        case 'error': {
          this.modal = Object.assign({}, {
            title: 'Error',
          });

          let content = '';

          response.errors.forEach((error) => {
            content += '* ' + error + "\n";
          });

          this.modal = Object.assign(this.modal, {
            content: content
          });
        }
      }

      document.getElementById('loader').classList.add('active');
      ApiRequest.all({
        page: this.page,
        per_page: this.perPage,
      }).then((response) => {
        const { total, data } = response.data;
        this.gridData = data;
        this.totalRows = total;
        this.$refs.modal.show();
        document.getElementById('loader').classList.remove('active');
      }).catch(() => {
        document.getElementById('loader').classList.remove('active');
      });
      ApiRequest.finishCall();
    },
  },
};
</script>
